import { apiClient } from '../lib/api-client';

export const financialInsightsService = {
  // Content endpoints
  getContents: (params = {}) => {
    return apiClient.get('/affluent/contents', { params }).then(res => res.data.data || []);
  },

  getContentById: (id) => {
    return apiClient.get(`/affluent/content/${id}`).then(res => res.data);
  },

  getContentBySlug: (slug) => {
    return apiClient.get(`/affluent/content/slug/${slug}`).then(res => res.data);
  },

  // Category endpoints
  getContentCategories: () => {
    return apiClient.get('/affluent/content-categories').then(res => res.data.data || []);
  },

  getContentCategoryById: (id) => {
    return apiClient.get(`/affluent/content-category/${id}`).then(res => res.data);
  },

  // Bookmark endpoints
  getBookmarks: () => {
    return apiClient.get('/affluent/bookmarks').then(res => res.data.data || []);
  },

  getBookmarksCount: () => {
    return apiClient.get('/affluent/bookmarks', { params: { count: true } }).then(res => res.data);
  },

  getBookmarkById: (id) => {
    return apiClient.get(`/affluent/bookmark/${id}`).then(res => res.data);
  },

  bookmarkContent: (contentId) => {
    return apiClient.post(`/affluent/bookmark/${contentId}`).then(res => res.data);
  },

  deleteBookmark: (id) => {
    return apiClient.delete(`/affluent/bookmark/delete/${id}`).then(res => res.data);
  },

  clearBookmarks: () => {
    return apiClient.delete('/affluent/bookmarks/clear').then(res => res.data);
  },
};
